export function linkOnClickSubmit(linkEl, linkDataAttrName, hiddenEl, submitEl) {
  $(linkEl).on('click', (e) => {
    e.preventDefault();
    $(hiddenEl).val($(e.currentTarget).attr(linkDataAttrName));
    $(submitEl).submit()
  });
}
